export default __webpack_public_path__ + "dc77e08607ae20531f6b28e4e979721a.svg";